<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import CMRCommon from './mixin';
import { mapGetters, mapState } from 'vuex';
import { filter, get, orderBy } from 'lodash';
import { planTypes, BILLING_CYCLE } from '@/common/constants';
import { isZoomMeetingAsAddonCard } from '@/plans/ZOOM_MEETING/common/utils';
import { planTypesForMeeting } from '@/views/config/addon-cards/index.vue';
import addonCustomSelect from '@/plans/mx/addonCustomSelect';
export default {
  mixins: [base, CMRCommon,addonCustomSelect],
  for: ()=> {
      const shouldHide = isZoomMeetingAsAddonCard();
      if(shouldHide) return [];
      return planTypesForMeeting();
  },
  data(){
    return {
      form:{
        billingCycle: BILLING_CYCLE.MONTHLY,
        selectedNumber: 1,
        //category: 'cmr30',
      }
    }
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
    this.productPlans = this.currentProductPlans;
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    planInfo() {
      return this.planMapFlat.filter((item) => item.type === this.planType && item.isVisible);
    },
    ...mapGetters(['getCurrentBasePlanInfo']),
    currentProductPlans() {
      return orderBy(
        filter(this.planMapFlat, (p) => p.type === planTypes.CMR),
        ['capacity'],
        'asc',
      );
    },
    lowestPlan() {
      return get(this.currentProductPlans, [0], {});
    },
  },
};
</script>
